import http from '@/http'
import { Part } from '@/interfaces/library'
import { search } from '@/controllers/global/search'

type PartSearchResult = {
  entityId?: number
  identifier?: string
}

export async function getPart (id: Number): Promise<Part> {
  const { data } = await http.get(`/parts/${id}`)
  return data
}

export async function findAccessiblePartByNumberAndSupplier (
  partNumber: string,
  supplierKey: string
): Promise<Part | null> {
  const limit = 100
  const normalizedSupplierKey = supplierKey.toLowerCase()
  let offset = 0
  let count = 0

  do {
    const { data, headers } = await search({
      limit,
      offset,
      q: `"${partNumber}"`,
      searchable_type: 'Part',
      supplier_key: supplierKey
    })
    const results = (data?.items ?? []) as PartSearchResult[]
    const exactMatches = results.filter(({ entityId, identifier }) =>
      identifier === partNumber && Number.isInteger(entityId)
    )
    const settledParts = await Promise.allSettled(
      exactMatches.map(({ entityId }) => getPart(entityId as number))
    )
    const part = settledParts.find(result =>
      result.status === 'fulfilled' &&
      result.value.supplierKey?.toLowerCase() === normalizedSupplierKey
    )
    if (part?.status === 'fulfilled') return part.value

    count = Number(headers?.['x-count']) || offset + results.length
    const nextOffset = Number(headers?.['x-offset']) + Number(headers?.['x-limit'])
    if (!results.length || !Number.isFinite(nextOffset) || nextOffset <= offset) break
    offset = nextOffset
  } while (offset < count)

  return null
}

export async function getPartSuggestionsForCart(id: number, params: any) {
  return await http.get(`/parts/${id}/suggestions/cart`, { params })
}
